module.exports = __webpack_public_path__ + "static/img/1.bd0369f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190417/1.jpg
// module id = A+Hw
// module chunks = 0